import { useLazyGetVesselPhotoQuery } from 'app/api/photo';
import { useState, useEffect } from 'react';
import styles from './VesselPhoto.module.scss';
import { Icon } from '../Icon/Icon';

interface Props {
  imo?: number;
}
export const VesselPhoto = ({ imo }: Props) => {
  const [vesselPhoto, setVesselPhoto] = useState<any>();

  const [getPhoto, getPhotoRequest] = useLazyGetVesselPhotoQuery();

  useEffect(() => {
    setVesselPhoto(null);

    if (typeof imo === 'number') {
      getPhoto(imo);
    }
  }, [imo]);

  useEffect(() => {
    if (getPhotoRequest.isSuccess) {
      const res = getPhotoRequest.data;
      if (res) {
        const reader = new FileReader();
        reader.readAsDataURL(res);
        reader.onloadend = () => {
          setVesselPhoto(reader.result);
        };
      }
    } else {
      setVesselPhoto(null);
    }
  }, [getPhotoRequest]);

  return vesselPhoto && getPhotoRequest.isSuccess && !getPhotoRequest.isFetching ? (
    <div className={styles.photo_container}>
      <img className={styles.photo} src={vesselPhoto} alt={`photo of vessel ${imo ? `with imo ${imo}` : null}`} />
    </div>
  ) : (
    <div className={styles.no_photo_container}>
      <div className={styles.no_photo}>
        {getPhotoRequest.isFetching ? (
          <span className={styles.loader}></span>
        ) : (
          <Icon name="placeholder-no-photo" width="80px" height="80px" color="var(--placeholders)" />
        )}
      </div>
    </div>
  );
};
